document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                speed: 4000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let slideSlider = document.querySelectorAll('.slide-slider');
    if(slideSlider){
        slideSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-sli-next",
                    prevEl: ".sw-sli-prev",
                },
                pagination: {
                    el: ".pagination-slider",
                    clickable: true,
                }
            });
        });
    }

    let cardSlider = document.querySelectorAll('.card-slider');
    if(cardSlider){
        cardSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                centeredSlides: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    760: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    }
                }
            });
        });
    }

    let sliderSpecials = document.querySelectorAll('.slider-specials');
    if(sliderSpecials){
        sliderSpecials.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    760: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                    }
                }
            });
        });
    }

    let awardsSlider = document.querySelectorAll('.awards-slider');
    if(awardsSlider){
        awardsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 3,
                        spaceBetween: 100,
                    },
                    760: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    }
                }
            });
        });
    }

    let cardSelSlider = document.querySelectorAll('.card-sel-slider');
    if(cardSelSlider){
        cardSelSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    1020: {
                        slidesPerView: 3,
                    },
                    760: {
                        slidesPerView: 2,
                    }
                }
            });
        });
    }

    let listSlider = document.querySelectorAll('.list-slider');
    if(listSlider){
        listSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

});